var chunkToChildrenMap = {
	"3390": [
		3342,
		2192
	],
	"8087": [
		3342,
		2192
	],
	"8293": [
		3342,
		2192
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) { Promise.all(promises).then(function() {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}); };